import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
export function HeroSection() {
  const scrollToOffer = () => {
    document.getElementById('offer-stack')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="pt-[180px] pb-[140px] px-6 max-w-7xl mx-auto" data-id="element-81">
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center" data-id="element-82">
        <div className="lg:col-span-3" data-id="element-83">
          <FadeIn data-id="element-84">
            <h2 className="uppercase tracking-[0.45em] text-sm text-amber font-semibold mb-6" data-id="element-85">
              THE CANINE BIOCLOCK PROTOCOL™
            </h2>
            <h1 className="mt-10 text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6" data-id="element-86">
              Hacking the Canine Biological Clock for 5+ Extra Years of
              Vitality.
            </h1>
            <p className="text-xl text-body leading-relaxed mb-10" data-id="element-87">
              The 3-Step Cellular Framework to neutralize the damage of
              processed kibble.
            </p>
            <div data-id="element-88">
              <CTAButton onClick={scrollToOffer} data-id="element-89">
                YES! I WANT 5+ EXTRA YEARS WITH MY DOG
              </CTAButton>
              <p className="text-muted text-xs mt-3 tracking-wide text-center" data-id="element-90">
                Instant Access • One-time secure payment of $27
              </p>
            </div>
          </FadeIn>
        </div>

        <div className="lg:col-span-2 relative" data-id="element-91">
          <FadeIn delay={0.2} data-id="element-92">
            <div className="absolute inset-0 bg-amber/20 blur-[100px] rounded-full transform scale-90 -z-10" data-id="element-93"></div>
            <img src="https://cdn.magicpatterns.com/uploads/jSAsHHFaawQqVtjnvTK96U/heylloyd-image-1772241081205.png" alt="The Canine BioClock Protocol Digital Bundle" className="w-full h-auto drop-shadow-2xl" data-id="element-94" />
          </FadeIn>
        </div>
      </div>
    </section>;
}